"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _broadcast = require('shared/selectors/broadcast');
var _campaignState = require('web/screens/Broadcast/campaignState');
var _hooks = require('web/services/hooks');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _useCampaignActions = require('./hooks/useCampaignActions'); var _useCampaignActions2 = _interopRequireDefault(_useCampaignActions);

var _Header = require('./Header'); var _Header2 = _interopRequireDefault(_Header);
var _Body = require('./Body'); var _Body2 = _interopRequireDefault(_Body);
var _Modals = require('web/screens/Broadcast/Modals');
var _ExportPhoneLogsModal = require('web/screens/Directory/TeamPage/ExportPhoneLogsModal'); var _ExportPhoneLogsModal2 = _interopRequireDefault(_ExportPhoneLogsModal);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _user = require('shared/selectors/user');
var _messageDraft = require('web/screens/Broadcast/Wizard/Message/messageDraft');
var _EditPanel = require('./EditPanel'); var _EditPanel2 = _interopRequireDefault(_EditPanel);
var _EditMessageDialog = require('./EditMessageDialog'); var _EditMessageDialog2 = _interopRequireDefault(_EditMessageDialog);
var _AddRecipientsDialogs = require('web/screens/Broadcast/Recipients/AddRecipientsDialogs'); var _AddRecipientsDialogs2 = _interopRequireDefault(_AddRecipientsDialogs);
var _leaveGuard = require('../leaveGuard');







const DISCARD_COPY = {
  message: "Your changes to the message haven't been saved.",
  details: "Your changes to the campaign details haven't been saved.",
}

const CampaignPage = ({ campaignKey, panel = null }) => {
  const campaign = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignByKey.call(void 0, state, campaignKey))
  const panelKind = _EditPanel.panelKindOf.call(void 0, panel)

  // Rev 30 Z2: Add more's dialogs add straight to the campaign.
  const [addMore, setAddMore] = _react.useState(null)
  const onAddExisting = _react.useCallback.call(void 0, () => setAddMore('existing'), [])
  const onAddFromCsv = _react.useCallback.call(void 0, () => setAddMore('csv'), [])
  const onCloseAddMore = _react.useCallback.call(void 0, () => setAddMore(null), [])
  const [focusVariable, setFocusVariable] = _react.useState(null)
  // A panel's unsaved edits, for the panel that reported them: a new panel
  // starts clean without a reset that could land after it reports (a
  // restored message draft is dirty from its first render, Rev 26 O2).
  const [dirtyPanel, setDirtyPanel] = _react.useState(null)
  const isPanelDirty = !!panel && dirtyPanel === panel
  const onDirtyChange = _react.useCallback.call(void 0, 
    (isDirty) => setDirtyPanel(d => isDirty ? panel : d === panel ? null : d),
    [panel],
  )
  // A navigation waiting on "Discard changes?"
  const [pendingLeave, setPendingLeave] = _react.useState





(null)

  /* Leaving an in-place edit asks before discarding unsaved work. */
  const requestPanel = _react.useCallback.call(void 0, 
    (target, go) => {
      const loss = _EditPanel.leaveLoss.call(void 0, panelKind, target, isPanelDirty)
      if (loss) setPendingLeave({ ...loss, go })
      else go()
    },
    [isPanelDirty, panelKind],
  )
  // Archiving the campaign, from here or its sidebar row, leaves the page
  // (once the server agrees).
  const guardLeave = _react.useCallback.call(void 0, 
    (go) => {
      const loss = _EditPanel.leaveLoss.call(void 0, panelKind, null, isPanelDirty)
      if (loss) setPendingLeave({ ...loss, go, isDeparture: true })
      else go()
    },
    [isPanelDirty, panelKind],
  )
  _leaveGuard.useRegisterLeaveGuard.call(void 0, campaignKey, guardLeave)
  const userKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const onConfirmDiscard = _react.useCallback.call(void 0, 
    () => {
      if (!pendingLeave) return
      // Discarding the message drops its kept draft too (Rev 26 O2).
      if (pendingLeave.lose === 'message') _messageDraft.clearMessageDraft.call(void 0, userKey, campaignKey)
      if (pendingLeave.isDeparture) {
        pendingLeave.go()
        setPendingLeave(null)
        return
      }
      setDirtyPanel(null)
      setFocusVariable(null)
      pendingLeave.go()
      setPendingLeave(null)
    },
    [pendingLeave, userKey, campaignKey],
  )

  const {
    isOpen: isQueueMessagesModalOpen,
    onOpen: onOpenQueueMessagesModal,
    onClose: onCloseQueueMessages,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isExportCampaignModalOpen,
    onOpen: onOpenExportCampaignModal,
    onClose: onCloseExportCampaignModal,
  } = _useToggle2.default.call(void 0, )

  // A start the server refused: the Send dialog reopens with its gate result.
  const [refusedGate, setRefusedGate] = _react.useState(null)
  // "Review recipients" from a blocked gate filters the table to the
  // recipients whose message can't send (M5).
  const [isReviewingBlocked, setIsReviewingBlocked] = _react.useState.call(void 0, false)

  const onGateRefused = _react.useCallback.call(void 0, 
    (gate) => {
      setRefusedGate(gate)
      onOpenQueueMessagesModal()
    },
    [onOpenQueueMessagesModal],
  )
  const onCloseQueueMessagesModal = _react.useCallback.call(void 0, 
    () => {
      setRefusedGate(null)
      onCloseQueueMessages()
    },
    [onCloseQueueMessages],
  )
  const onReviewRecipients = _react.useCallback.call(void 0, 
    () => {
      onCloseQueueMessagesModal()
      setIsReviewingBlocked(true)
    },
    [onCloseQueueMessagesModal],
  )
  const onStopReviewing = _react.useCallback.call(void 0, () => setIsReviewingBlocked(false), [])

  // Opens the message dialog; never closes it.
  const onOpenMessage = _react.useCallback.call(void 0, 
    () => requestPanel('message', () => {
      _actions2.default.gotoCampaignWizard(campaignKey, 'message')
    }),
    [campaignKey, requestPanel],
  )
  // G4: the Edit message button toggles; clicking it while open is Cancel
  // (with the discard prompt when there are unsaved edits).
  const onToggleMessage = _react.useCallback.call(void 0, 
    () => panelKind === 'message'
      ? requestPanel(null, () => _actions2.default.gotoCampaignPage(campaignKey))
      : onOpenMessage(),
    [campaignKey, requestPanel, panelKind, onOpenMessage],
  )
  // A refused CSV's "Set a default for <var>": the message, on that variable.
  const onSetDefault = _react.useCallback.call(void 0, 
    (variable) => {
      setFocusVariable(variable)
      onOpenMessage()
    },
    [onOpenMessage],
  )
  const onEditDetails = _react.useCallback.call(void 0, 
    () => requestPanel('details', () => _actions2.default.gotoCampaignWizard(campaignKey, 'details')),
    [campaignKey, requestPanel],
  )
  const onClosePanel = _react.useCallback.call(void 0, 
    () => requestPanel(null, () => _actions2.default.gotoCampaignPage(campaignKey)),
    [campaignKey, requestPanel],
  )
  const onMessageSaved = _react.useCallback.call(void 0, 
    () => {
      setDirtyPanel(null)
      setFocusVariable(null)
      _actions2.default.gotoCampaignPage(campaignKey)
    },
    [campaignKey],
  )
  const onFixMessage = _react.useCallback.call(void 0, 
    () => {
      onCloseQueueMessagesModal()
      onOpenMessage()
    },
    [onCloseQueueMessagesModal, onOpenMessage],
  )

  const {
    onStartCampaign,
    onPauseCampaign,
    onRemovePatients,
    onDequeuePatients,
    onExportCampaign,
  } = _useCampaignActions2.default.call(void 0, campaignKey, onGateRefused)
  // Release review F-1: a campaign stopped with only queued messages left
  // resumes them directly; the Send dialog only queues not scheduled ones.
  const isQueuedOnly = !!campaign && _campaignState.isResumeQueuedOnly.call(void 0, campaign)
  const onQueueOrResume = _react.useCallback.call(void 0, 
    () => isQueuedOnly ? onStartCampaign(0, null) : onOpenQueueMessagesModal(),
    [isQueuedOnly, onStartCampaign, onOpenQueueMessagesModal],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Header2.default, {
        campaignKey: campaignKey,
        onEditDetails: onEditDetails,
        onExportCampaign: onExportCampaign ? onOpenExportCampaignModal : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
      )
      , _react2.default.createElement(_Body2.default, {
        campaignKey: campaignKey,
        onPauseCampaign: onPauseCampaign,
        onQueueMessages: onQueueOrResume,
        onEditMessage: onToggleMessage,
        onAddExisting: onAddExisting,
        onAddFromCsv: onAddFromCsv,
        onRemovePatients: onRemovePatients,
        onDequeuePatients: onDequeuePatients,
        isReviewingBlocked: isReviewingBlocked,
        onStopReviewing: onStopReviewing,
        activePanel: panelKind,
        panel: panelKind === 'details' && campaign && (
          _react2.default.createElement(_EditPanel2.default, {
            campaign: campaign,
            onDirtyChange: onDirtyChange,
            onClose: onClosePanel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}}
          )
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
      )
      ,  campaign && (
        _react2.default.createElement(_EditMessageDialog2.default, {
          isOpen: panelKind === 'message',
          campaign: campaign,
          focusVariable: focusVariable,
          onDirtyChange: onDirtyChange,
          onClose: onClosePanel,
          onSaved: onMessageSaved, __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}}
        )
      )
      ,  campaign && (
        _react2.default.createElement(_AddRecipientsDialogs2.default, {
          campaign: campaign,
          open: addMore,
          onClose: onCloseAddMore,
          onSetDefault: onSetDefault, __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}
        )
      )
      , _react2.default.createElement(_Modals.QueueMessagesModal, {
        isOpen: isQueueMessagesModalOpen,
        onClose: onCloseQueueMessagesModal,
        campaignKey: campaignKey,
        onStartCampaign: onStartCampaign,
        refusedGate: refusedGate,
        onReviewRecipients: onReviewRecipients,
        onFixMessage: onFixMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
      )
      , _react2.default.createElement(_Modal2.default, {
        isOpen: !!pendingLeave,
        title: "Discard changes?" ,
        size: "xs",
        onClose: () => setPendingLeave(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}

        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 266}},  pendingLeave && DISCARD_COPY[pendingLeave.lose] )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Keep editing" ,
          onSecondaryBtnClick: () => setPendingLeave(null),
          primaryBtnLabel: "Discard",
          primaryBtnTheme: "danger",
          onPrimaryBtnClick: onConfirmDiscard, __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}
        )
      )
      ,  onExportCampaign && isExportCampaignModalOpen && (
        _react2.default.createElement(_ExportPhoneLogsModal2.default, {
          isOpen: isExportCampaignModalOpen,
          onClose: onCloseExportCampaignModal,
          onProceed: onExportCampaign, __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
        )
      )
    )
  )
}

exports. default = CampaignPage
